import { RouteConfig } from "vue-router";
import { safeImport } from "@/utils/SafeImport";

const routes: Array<RouteConfig> = [
  {
    path: "/search",
    name: "search",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.search" */ "../views/SearchEverywhere.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
];

export default routes;
